import * as React from 'react';
import { TRAINING_DOMAINS } from '../../base/constants';
import { DomainContainer } from '../../exercises';
import './TabViews.scss';

interface IComparisonViewProps {
  userId?: number;
}

export const ComparisonView: React.FC<IComparisonViewProps> = ({ userId }) => {
  return (
    <div className="statistics-tab-content" data-testid="comparison-tab">
      {TRAINING_DOMAINS.map((domain) => (
        <DomainContainer key={domain} domain={domain} numberOfColumns={2} userId={userId} />
      ))}
    </div>
  );
};

export default ComparisonView;
